module.exports = __webpack_public_path__ + "static/img/marie.94384a47.jpg";